import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,[_c(VRow,[_c(VCol,[(_vm.failure)?_c(VAlert,{staticClass:"mt-0",attrs:{"type":"error","dense":"","text":""}},[_vm._v(" "+_vm._s(_vm.failure)+" ")]):_c(VList,_vm._l((_vm.names),function(name,index){return _c(VListItem,{key:index},[_c(VListItemContent,[_c(VListItemTitle,[_vm._v(_vm._s(name))])],1)],1)}),1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }